import { assetUrl } from "./assets";

// An explicit empty icon prevents the browser from reusing /favicon.ico from a
// different merchant on this origin when this merchant has no configured icon.
export const EMPTY_FAVICON = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3C/svg%3E";

/** Keep a single, tenant-qualified browser icon; callers choose source priority. */
export function setFavicon(value, options) {
  const href = assetUrl(value, options) || EMPTY_FAVICON;
  const links = Array.from(document.head.querySelectorAll(
    "link[rel~='icon'], link[rel='apple-touch-icon'], link[rel='apple-touch-icon-precomposed'], link[rel='mask-icon']"
  ));
  let link = links.find(candidate => candidate.dataset.siteFavicon === "true");
  if (!link) {
    link = document.createElement("link");
    document.head.appendChild(link);
  }
  links.forEach(candidate => { if (candidate !== link) candidate.remove(); });
  link.setAttribute("rel", "icon");
  link.setAttribute("data-site-favicon", "true");
  link.setAttribute("href", href);
  return href;
}
